import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step9 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("treat");

  const handleOptionClick = (value) => {
    onAnswer("treat", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>How do women usually treat you?</QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="treat"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step9;
